export const GET_NOTIFICATIONS = 'notifications';
export const GET_NOTIFICATIONS_UNREAD_COUNT = 'notifications-unread-count';
export const GET_DASHBOARD = 'dashboard';
export const GET_ENROLLMENTS = 'enrollments';
export const GET_ENROLLMENT_TERMS = 'enrollment-terms';
export const GET_ENROLLMENT_INTAKES = 'enrollment-intakes';
export const GET_ENROLLMENT_TERM = 'enrollment-term';
export const GET_MODULE_LESSONS = 'module-lessons';
export const GET_ENROLLMENT_LESSON = 'enrollment-lesson';
export const GET_ASSIGNMENTS = 'assignments';
export const GET_ASSIGNMENT_SUBMISSION = 'assignment-submission';
export const GET_PROFILE = 'profile';
export const GET_TEACHER_ASSIGNMENTS = 'teacher-assignments';
export const GET_TEACHER_ASSIGNMENTS_SUMMARY = 'teacher-assignments-summary';
export const GET_TEACHER_ASSIGNMENTS_DETAILS = 'teacher-assignments-details';
export const GET_TEACHER_ASSIGNMENTS_COURSES = 'teacher-assignments-courses';
export const GET_TEACHER_LESSON_BASE = 'teacher-lesson-base';
export const GET_TEACHER_LESSON_STUDENTS = 'teacher-lesson-students';
export const GET_TEACHER_LESSON_SUBMISSION = 'teacher-lesson-submission';
export const GET_TEACHER_COURSES = 'teacher-courses';
export const GET_TEACHER_INTAKES = 'teacher-intakes';
export const GET_TEACHER_TERMS = 'teacher-terms';
export const GET_TEACHER_TERM_MODULES = 'teacher-term-modules';
export const GET_TEACHER_TERM_STUDENTS = 'teacher-term-students';
export const GET_TEACHER_LESSONS = 'teacher-lessons';
export const GET_TEACHER_LESSON_DETAILS = 'teacher-lesson-details';
export const GET_TEACHER_ATTENDANCE = 'teacher-attendance';
export const GET_TEACHER_ATTENDANCE_HISTORY = 'teacher-attendance-history';
export const GET_TEACHER_MODULE_ATTENDANCE = 'teacher-module-attendance';
export const GET_STUDENT_SCORM = 'student-scorm';
export const GET_TEACHER_SCORM = 'teacher-scorm';
export const GET_STUDENT_REQUESTS = 'student-requests';
export const GET_TEACHER_REQUESTS = 'teacher-requests';
export const GET_CALENDAR = 'calendar';
export const GET_CALENDAR_SUBSCRIPTION = 'calendar-subscription';
export const GET_CATALOGUE_COURSE = 'catalogue-course';
export const GET_STUDENT_INVOICES_BALANCE = 'student-invoices-balance';
export const GET_STUDENT_BADGES = 'student-badges';
export const GET_BLOGS = 'blogs';
export const GET_BLOG = 'blog';
